import { z } from 'zod';
import { ProdutoLoteEstoqueSchema } from './ProdutoLoteEstoque';

export enum ProdutoLoteStatus {
    Ativo = 1,
    Expirado = 2,
    Encerrado = 3,
}

export const ProdutoLoteSchema = z.object({
    estoque: ProdutoLoteEstoqueSchema.array().nullable(),
    prl_chave: z.string(),
    prl_data_fabricacao: z.string().nullable(),
    prl_data_insercao: z.string(),
    prl_data_vencimento: z.string(),
    prl_empresa_idpk: z.number(),
    prl_idpk: z.string(),
    prl_localizacao: z.string().nullable(),
    prl_produto_idpk: z.number(),
    prl_status: z.enum(ProdutoLoteStatus),
    prl_ultima_alteracao: z.string().nullable(),
});

export type ProdutoLote = z.infer<typeof ProdutoLoteSchema>;
